import { Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TemplateRenderOption = option => {
  return (
    <Row key={option?.id} display="flex" flexDirection="column" gridGap="S200">
      <Row alignItems="center">{option?.name}</Row>
      {option?.createdBy && (
        <View display={'flex'} gridGap="S200" flexDirection="row">
          <Text fontSize="T100">
            <FormattedMessage
              id="app.dropdown.option.label.createdBy"
              defaultMessage="Created by:"
            />
          </Text>
          <Spacer width={'7px'} />
          <Text fontSize="T100" style={{ fontWeight: 'bold' }}>
            {option?.createdBy}
          </Text>
        </View>
      )}
    </Row>
  );
};

export default TemplateRenderOption;
